<template>
  <div class="p-6 bg-indigo-200 min-h-screen flex flex-col justify-center items-center">
    <div class="w-full max-w-md">
      <InertiaLink :href="route('staff.login')">
        <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      </InertiaLink>
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <h1 class="text-center font-bold text-3xl">Verification!</h1>
          <p class="text-center text-sm mt-3 leading-relaxed">We’ve sent an OTP to your registered mobile number. Please enter it below to continue.</p>
          <div class="mx-auto mt-6 w-24 border-b-2" />
          <text-input v-model="form.otp" :errors="form.errors.otp" class="mt-6" label="OTP" placeholder="Enter OTP..." />
          <div class="flex w-full justify-end mt-1">
            <loading-button :loading="form.processing" tabindex="-1" type="button" @click="requestNewOtp">Resend OTP</loading-button>
          </div>
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center">
          <InertiaLink class="hover:underline" tabindex="-1" :href="route('staff.login')">Back to Login</InertiaLink>
          <loading-button :loading="form.processing" class="btn-primary" type="submit">Continue</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  import TextInput from "../../../Shared/TextInput.vue";
  import LoadingButton from "../../../Shared/LoadingButton.vue";
  import Logo from "@/Shared/Logo.vue";

  export default {
    components: {LoadingButton, TextInput, Logo},
    metaInfo: { title: 'Verify OTP' },
    name: 'Verify',
    props: {
      token: String,
    },

    data() {
      return {
        form: this.$inertia.form({
          otp: null,
        })
      }
    },

    methods: {
      submit() {
        this.form.post(route('staff.login.verify.check', this.token))
      },

      requestNewOtp() {
        this.form.post(route('staff.login.request-otp', this.token))
      }
    }
  }
</script>
